import { createFileRoute } from '@tanstack/react-router'
import { FileText, ShieldAlert, ShoppingBag, Scale, AlertTriangle, Mail, UserCheck, Clock, Handshake } from 'lucide-react'

export const Route = createFileRoute('/_regular/terms-of-service/')({
  component: TermsOfServicePage,
  head: () => ({
    meta: [
      { title: 'شروط الاستخدام | سكيكيمة' },
      {
        name: 'description',
        content: 'شروط وأحكام استخدام منصة سكيكيمة للمتاجر والمستخدمين.',
      },
    ],
  }),
})

function TermsOfServicePage() {
  const sections = [
    {
      icon: FileText,
      title: '١. تعريفات',
      content: (
        <ul className="list-disc space-y-2 pr-5 mt-2">
          <li><strong>المنصة:</strong> موقع وتطبيق سكيكيمة (skikima.store).</li>
          <li><strong>المستخدم:</strong> أي شخص يزور المنصة أو يسجل فيها.</li>
          <li><strong>الزائر:</strong> مستخدم عادي لديه حساب (دور visitor).</li>
          <li><strong>صاحب المتجر:</strong> مستخدم أنشأ متجراً واحداً أو أكثر (دور store).</li>
          <li><strong>المحتوى:</strong> النصوص، الصور، المنتجات، التعليقات، وغيرها من البيانات المنشورة.</li>
        </ul>
      ),
    },
    {
      icon: UserCheck,
      title: '٢. الأهلية',
      content: (
        <ul className="list-disc space-y-2 pr-5 mt-2">
          <li>تمتلك الأهلية القانونية الكاملة (عمر ١٨ سنة على الأقل).</li>
          <li>تقدم معلومات صحيحة وكاملة عند التسجيل.</li>
          <li>تتحمل مسؤولية الحفاظ على سرية حسابك وكلمة مرورك.</li>
          <li>ستخطرنا فوراً بأي اختراق أو استخدام غير مصرح به لحسابك.</li>
        </ul>
      ),
    },
    {
      icon: ShoppingBag,
      title: '٣. إنشاء وإدارة المتاجر',
      content: (
        <ul className="list-disc space-y-2 pr-5 mt-2">
          <li>لكل زائر الحق في إنشاء متجر واحد أو أكثر (كل متجر له حساب مستقل).</li>
          <li>يجب أن يتوافق نشاط المتجر مع القوانين المغربية والآداب العامة.</li>
          <li>يحظر بيع المنتجات المقلدة، المحظورة (مخدرات، أسلحة، محتوى إباحي)، أو التي تنتهك حقوق الملكية الفكرية للغير.</li>
          <li>نحتفظ بالحق في مراجعة ورفض أو إزالة أي متجر أو منتج يخالف هذه الشروط دون إشعار مسبق.</li>
          <li>عملية الموافقة على المتجر الجديد أو تعديلاته تتم بواسطة فريقنا وقد تستغرق حتى ٤٨ ساعة.</li>
        </ul>
      ),
    },
    {
      icon: ShieldAlert,
      title: '٤. حقوق الملكية الفكرية',
      content: (
        <ul className="list-disc space-y-2 pr-5 mt-2">
          <li><strong>المحتوى الخاص بالمنصة:</strong> التصميم، الشعار، النصوص، البرمجيات – جميعها مملوكة لسكيكيمة.</li>
          <li><strong>المحتوى الذي ترفعه:</strong> أنت تحتفظ بحقوق ملكيتك، لكنك تمنحنا ترخيصاً غير حصري، عالمياً، خالياً من الإتاوات لنشر هذا المحتوى وعرضه على المنصة.</li>
          <li>أنت مسؤول عن التأكد من أن لديك الحق في استخدام ونشر أي محتوى ترفعه (صور منتجات، علامات تجارية، إلخ).</li>
        </ul>
      ),
    },
    {
      icon: AlertTriangle,
      title: '٥. السلوك المحظور',
      content: (
        <ul className="list-disc space-y-2 pr-5 mt-2">
          <li>انتحال شخصية أخرى أو استخدام حساب غير مصرح به.</li>
          <li>نشر محتوى ضار (فيروسات، برمجيات خبيثة).</li>
          <li>جمع بيانات المستخدمين الآخرين دون موافقتهم.</li>
          <li>التلاعب بآليات التقييم أو التصويت.</li>
          <li>القيام بأي نشاط قد يعطل المنصة أو يضر بأدائها.</li>
          <li>استخدام المنصة لنقل مواد غير قانونية أو مسيئة أو عنصرية.</li>
        </ul>
      ),
    },
    {
      icon: Handshake,
      title: '٦. المسؤولية',
      content: (
        <ul className="list-disc space-y-2 pr-5 mt-2">
          <li>نحن نقدم المنصة “كما هي” دون ضمانات بأنها ستكون خالية من الأخطاء أو متاحة باستمرار.</li>
          <li>سكيكيمة ليست مسؤولة عن أي خسائر مباشرة أو غير مباشرة ناتجة عن استخدام المنصة، بما في ذلك فقدان البيانات أو الأرباح.</li>
          <li>أنت مسؤول وحيد عن دقة منتجاتك وتسعيرها وتوفرها، وعن تنفيذ أي عمليات بيع تتم خارج المنصة.</li>
          <li>في حال حدوث نزاع بين مستخدمين، فإنك توافق على محاولة حله وديًا، وسكيكيمة غير مسؤولة عن أي نزاع ينشأ بين مستخدميها.</li>
        </ul>
      ),
    },
    {
      icon: Clock,
      title: '٧. الإنهاء والتعليق',
      content: (
        <>
          <p>يحق لسكيكيمة تعليق أو إنهاء حسابك أو إزالة محتوى خاص بك إذا:</p>
          <ul className="list-disc space-y-2 pr-5 mt-2">
            <li>خالفت هذه الشروط أو القوانين المعمول بها.</li>
            <li>تلقينا شكاوى موثقة بشأن نشاطك.</li>
            <li>لم تتفاعل مع المنصة لفترة طويلة (أكثر من سنة).</li>
          </ul>
          <p className="mt-2">في حالة الإنهاء، سنحاول إشعارك مسبقاً (إلا إذا كان الانتهاك خطيراً). لك الحق في تصدير بياناتك خلال مهلة معقولة.</p>
        </>
      ),
    },
    {
      icon: Scale,
      title: '٨. القانون الواجب التطبيق',
      content: (
        <p>تخضع هذه الشروط وتفسر وفقاً للقوانين المغربية. أي نزاع ينشأ عنها سيكون الاختصاص القضائي فيه للمحاكم المغربية بمدينة العيون.</p>
      ),
    },
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30" dir="rtl">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20 md:py-28">
        <div className="absolute inset-0 bg-grid-primary/5 [mask-image:radial-gradient(ellipse_at_center,white,transparent)]" />
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-1 text-sm text-primary mb-6">
            <FileText className="h-4 w-4" />
            <span>الاتفاقية القانونية</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
            شروط الاستخدام
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            باستخدامك منصتنا، فإنك توافق على الالتزام بهذه الشروط
          </p>
          <p className="text-sm text-muted-foreground mt-4">آخر تحديث: ١ يونيو ٢٠٢٦</p>
        </div>
      </section>

      {/* Content Cards */}
      <section className="container mx-auto px-4 pb-20">
        <div className="max-w-3xl mx-auto space-y-6">
          {sections.map((section, idx) => (
            <div key={idx} className="group relative rounded-2xl border bg-card p-6 transition-all hover:shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <div className="rounded-full bg-primary/10 p-2 text-primary">
                  <section.icon className="h-5 w-5" />
                </div>
                <h2 className="text-xl font-semibold">{section.title}</h2>
              </div>
              <div className="text-muted-foreground leading-relaxed space-y-2">
                {section.content}
              </div>
            </div>
          ))}

          {/* Contact Card */}
          <div className="rounded-2xl border bg-gradient-to-br from-primary/5 to-transparent p-6 text-center">
            <Mail className="h-8 w-8 text-primary mx-auto mb-3" />
            <h3 className="text-lg font-semibold mb-2">استفسارات قانونية؟</h3>
            <p className="text-muted-foreground mb-4">تواصل مع فريقنا القانوني.</p>
            <a
              href="mailto:contact@skikima.store"
              className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition"
            >
              <Mail className="h-4 w-4" />
              contact@skikima.store
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}